$(document).on('hide.bs.modal', '#preview-modal', function() {
  $('video', this).trigger('pause');
  if (window.players != null) {
    return $.each(window.collection, function() {
      return this.pause();
    });
  }
});
